import CloseIcon from "@mui/icons-material/Close";
import HistoryIcon from "@mui/icons-material/History";
import { ModalShell } from "./ModalShell";

export function HistoricItemNamesModal({
  names,
  loading,
  onClose,
  onDelete,
  onSelect,
}) {
  return (
    <ModalShell
      icon={<HistoryIcon />}
      title="Use Historic Product Names"
      subtitle="Choose a saved name or remove one from the collection."
      onClose={onClose}
    >
      <div className="historic-name-grid" aria-busy={loading}>
        {loading && (
          <div className="loading-banner" role="status">
            <span className="loading-spinner" /> Loading names
          </div>
        )}
        {!loading && names.length === 0 && (
          <div className="empty-state compact-empty historic-name-empty">
            No reusable names are available.
          </div>
        )}
        {!loading &&
          names.map((record) => (
            <div className="historic-name-card-shell" key={record.id}>
              <button
                type="button"
                className="historic-name-card"
                onClick={() => onSelect(record)}
              >
                <HistoryIcon />
                <span>{record.item_name}</span>
              </button>
              <button
                type="button"
                className="card-delete-button"
                aria-label={`Delete historic name ${record.item_name}`}
                onClick={() => onDelete(record)}
              >
                <CloseIcon fontSize="small" />
              </button>
            </div>
          ))}
      </div>
    </ModalShell>
  );
}
